export const littlemanStyles = {
	header: {
		backgroundColor: '#f4f4f4',
	},
	sidebar: {
		backgroundColor: '#262626',
		color: 'white',
	},
	button: {
		backgroundColor: '#ffdb00',
		color: '#000',
		border: '1px solid #000',
		fontWeight: 600,
		':hover': {
			color: '#000',
			backgroundColor: '#ffc300',
			borderColor: '#000',
		},
	},
	text: {
		color: '#262626',
	},
	title: {
		color: 'black',
	},
	table: {
		headerBackgroundColor: '#f4f4f4',
		headerTextColor: '#262626',
	},
	platformName: {
		name: 'Little Man Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/littleMan/little-man-icon.png',
			height: 40,
			width: 40,
		},
		large: {
			src: '/littleMan/little-man-logo-text-2x.png',
			height: 45,
			width: 125,
		},
	},
	favicon: {
		src: '/littleMan/little-man-icon.png',
	},
	socials: {
		x: 'https://twitter.com/LilManParking',
		facebook: 'https://www.facebook.com/LittleManParking',
		linkedIn: 'https://www.linkedin.com/company/little-man-parking/',
	},
	siteUrl: 'https://littlemanparking.com/',
	orgName: 'Little Man Parking',
};
